var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Planificado" } },
                        [
                          _vm._t("prependPlanificado"),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.kilometrajePlanificado.label,
                                  disabled: ""
                                },
                                model: {
                                  value:
                                    _vm.formFields.kilometrajePlanificado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.kilometrajePlanificado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.kilometrajePlanificado.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.horasMotorPlanificado.label,
                                  disabled: ""
                                },
                                model: {
                                  value:
                                    _vm.formFields.horasMotorPlanificado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.horasMotorPlanificado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.horasMotorPlanificado.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.tiempoPlanificado.label,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.tiempoPlanificado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tiempoPlanificado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.tiempoPlanificado.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Realizado" } },
                        [
                          _vm._t("prependRealizado"),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.kilometrajeRealizado.label,
                                  disabled: ""
                                },
                                model: {
                                  value:
                                    _vm.formFields.kilometrajeRealizado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.kilometrajeRealizado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.kilometrajeRealizado.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.horasMotorRealizado.label,
                                  disabled: ""
                                },
                                model: {
                                  value:
                                    _vm.formFields.horasMotorRealizado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.horasMotorRealizado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.horasMotorRealizado.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label:
                                    _vm.formFields.tiempoMotorRealizado.label,
                                  id: _vm.formFields.tiempoMotorRealizado.id,
                                  disabled: "",
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tiempoMotorRealizado.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.tiempoMotorRealizado.id
                                },
                                model: {
                                  value:
                                    _vm.formFields.tiempoMotorRealizado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tiempoMotorRealizado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.tiempoMotorRealizado.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.horasHonbre.label,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.horasHonbre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.horasHonbre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.horasHonbre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.costos.label,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.costos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.costos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.costos.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.taller.label,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.taller.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.taller,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.taller.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.responsable.label,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.responsable.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.responsable,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.responsable.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label:
                                    _vm.formFields.fechaIngresoTaller.label,
                                  id: _vm.formFields.fechaIngresoTaller.id,
                                  disabled: "",
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaIngresoTaller.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.fechaIngresoTaller.id
                                },
                                model: {
                                  value:
                                    _vm.formFields.fechaIngresoTaller.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaIngresoTaller,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.fechaIngresoTaller.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label: _vm.formFields.fechasalidaTaller.label,
                                  id: _vm.formFields.fechasalidaTaller.id,
                                  disabled: "",
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechasalidaTaller.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.fechasalidaTaller.id
                                },
                                model: {
                                  value: _vm.formFields.fechasalidaTaller.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechasalidaTaller,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.fechasalidaTaller.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c("br"),
                      _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                        _c(
                          "div",
                          { attrs: { align: "left" } },
                          [
                            _c("v-flex", { attrs: { md12: "" } }, [
                              _c("h2", { staticClass: "h2_title" }, [
                                _vm._v("Actividades")
                              ])
                            ])
                          ],
                          1
                        )
                      ]),
                      _c("v-divider"),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c("MantenedorGrid", {
                            attrs: { "grid-options": _vm.computedGridOptions }
                          })
                        ],
                        1
                      ),
                      _c("br"),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Actividades Extra Realizadas" } },
                        [
                          _vm._t("prependActividadesExtra"),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md12: "" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: _vm.formFields.actividadesExtra.label,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.actividadesExtra.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.actividadesExtra,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.actividadesExtra.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }